(function(){
    'use strict';

    angular
        .module('elogbooks.admin.settings')
        .controller('AdminSpillageDisplaySettingsController', AdminSpillageDisplaySettingsController);

    function AdminSpillageDisplaySettingsController(
        $controller,
        lodash,
        settingsCollection,
        siteAssociateTypesCollection,
        recurrenceRulesService,
        elbSettings,
        $state,
        module,
        modulesService
    ) {
        const vm = this;
        const base = $controller('AdminDisplaySettingsController', {
            lodash: lodash,
            settingsCollection: settingsCollection,
            settingsFields: [
                'spillage_open_chase_freq_before',
                'spillage_open_chase_freq_after',
                'spillage_accepted_chase_freq_before',
                'spillage_accepted_chase_freq_after',
                'spillage_in_progress_chase_freq_before',
                'spillage_in_progress_chase_freq_after',
                'spillage_escalation_interval_repeat',
                'spillage_escalation_interval',
                'spillage_escalation_siteassociate_type'
            ],
            recurrenceRulesService: recurrenceRulesService,
            elbSettings: elbSettings,
            $state: $state,
            module: module,
            modulesService: modulesService
        });

        angular.extend(vm, base);

        if (siteAssociateTypesCollection && siteAssociateTypesCollection.siteAssociateTypes) {
            const selectedAssociateType = lodash.find(siteAssociateTypesCollection.siteAssociateTypes, (element) => {
                return element.id === vm.settings.spillage_escalation_siteassociate_type.value;
            });

            if (typeof selectedAssociateType !== 'undefined') {
                vm.settings.spillage_escalation_siteassociate_type.value = selectedAssociateType.name;
            }
        }
    }
})();
